import {SidebarTrigger} from '@tinct/web-components';
import {ReactNode} from 'react';
import {cn} from '@tinct/core-utils';

type LayoutTopbarProps = {
  breadcrumbs?: ReactNode;
  buttons?: ReactNode[];
  className?: string;
};

export function LayoutTopbar(props: LayoutTopbarProps) {
  const { buttons, className, breadcrumbs } = props;

  return (
    <div className={cn("bg-background relative flex h-12 shrink-0 items-center justify-between px-4 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12 md:h-16", className)}>
      {/* Left side - Sidebar trigger */}
      <div className="flex items-center gap-4">
        <SidebarTrigger className="-ml-1" />
        {breadcrumbs}
      </div>

      {/* Center - Search input */}
      <div className="absolute left-1/2 top-1/2 w-[373px] -translate-x-1/2 -translate-y-1/2">
        {/*<DocumentationSearchInput*/}
        {/*  source={[*/}
        {/*    {*/}
        {/*      value: '1',*/}
        {/*      label: 'Getting Started',*/}
        {/*      url: '/docs/getting-started',*/}
        {/*      category: 'Guides',*/}
        {/*    },*/}
        {/*    {*/}
        {/*      value: '2',*/}
        {/*      label: 'API Reference',*/}
        {/*      url: '/docs/api',*/}
        {/*      description: 'Full API documentation',*/}
        {/*    },*/}
        {/*  ]}*/}
        {/*  placeholder="Search..."*/}
        {/*  shortcut="⌘K"*/}
        {/*  className="w-full"*/}
        {/*  onNavigate={(url) => navigate(url)}*/}
        {/*/>*/}
      </div>

      <div className="flex items-center gap-4">
        {buttons &&
          buttons.length > 0 &&
          buttons.map((button, index) => <div key={index}>{button}</div>)}
      </div>
    </div>
  );
}
